import Vue from "vue"

/**权限指令：可以控制页面上任何一个元素**/
Vue.directive('has', {
    bind: function (el, binding) {
        if (!Vue.prototype.$_has(binding.value)) {
            if (!el.parentNode) {
                el.style.display = 'none'
            } else {
                el.parentNode.removeChild(el)
            }
        }
    }
});

//权限检查方法
Vue.prototype.$_has = function (value) {
    let isExist = true;
    if (value != undefined) {
        let permissions = [];
        let permissionAll = JSON.parse(localStorage.getItem("permission"));
        if (permissionAll) {
            permissions = permissionAll.filter((p) => p.privilegeType === '1');
            // console.log('permissions测试',permissions)
        }
        let userpermissions = [];
        for (let menu of permissions) {
            userpermissions.push(menu.privilegeCode);
            // console.log(menu);
        }
        // console.log('permissions测试',userpermissions,value)

        if (!userpermissions.includes(value)) {
            isExist = false;
        }
    }
    return isExist;
};